import { createFileRoute } from "@tanstack/react-router";
import { OrganizationAdminFamilyDetailPage } from "./_families/-components/family-detail-page";
import { parseFamilyIdParams } from "@/lib/route-params";
import { z } from "zod";

const familyDetailSearchSchema = z.object({
  tab: z.string().catch("details"),
});

export const Route = createFileRoute("/_app/organizations/$organizationId/admin/families_/$familyId")({
  params: {
    parse: parseFamilyIdParams,
  },
  validateSearch: familyDetailSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { familyId, organizationId } = Route.useParams();
  const { tab } = Route.useSearch();

  return <OrganizationAdminFamilyDetailPage familyId={familyId} organizationId={organizationId} tab={tab} />;
}
